export default __webpack_public_path__ + "static/media/chat5.8584fe6e.jpg";